const baseUser = '/api/user';
const config = {
  session: {
    loginKey: 'twe_logged',
    loginTime: 'login_time',
    userKey: 'twe_userInfo',
    mode: 'mode'
  },
  /* 节流延时 */
  delay: 500,
  /* 刷新等待时长 */
  freshenTime: 200,
  cookie: {
    default: {
      path: '/cio/'
    },
    userKey: 'UUID',
    smsLoginKey: 'UUID_SMS'
  },
  ajax: {
    _get: {
      getUserInfoByToken: baseUser + '/getUserInfoByToken'
    },
    _post: {
      login: baseUser + '/login'
    }
  }
};
export default config;



// WEBPACK FOOTER //
// ./src/config.js